import { CartOffIcon } from './CartOffIcon';

/**
 * author: Google
 * id 05455801-C523-420A-A961-868ABA3DF636
 * name cart-off
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-off.svg
 * tags
 * - Shopping 
 */
export const RemoveShoppingCartIcon = CartOffIcon;
export default RemoveShoppingCartIcon